(function () {
  var MIN_CENTS = window.orderMinimumCents || 98900;
  var cartTotalCents = window.cartTotalCents || 0;

  function formatMoney(cents) {
    var moneyFormat = window.shopMoneyFormat || '${{amount}}';
    var precision = moneyFormat.indexOf('amount_no_decimals') !== -1 ? 0 : 2;
    var amount = (Number(cents) / 100).toFixed(precision);
    var parts = amount.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    var value = parts[1] ? dollars + '.' + parts[1] : dollars;
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function updateProgressElement(progress, currentCents, isProductMode) {
    var unlocked = currentCents >= MIN_CENTS;
    var remaining = Math.max(MIN_CENTS - currentCents, 0);
    var percent = Math.min((currentCents / MIN_CENTS) * 100, 100);

    progress.classList.toggle('is-complete', unlocked);
    var fill = progress.querySelector('[data-order-minimum-fill]');
    if (fill) fill.style.width = percent + '%';

    var message = progress.querySelector('[data-order-minimum-message]');
    if (!message) return;

    if (isProductMode) {
      // The real Buy It Now button only ever renders server-side (see
      // buy-buttons.liquid) - it can't appear on this page without a
      // reload even once this message says "unlocked", so word it as an
      // instruction rather than implying the button just appeared.
      message.textContent = unlocked
        ? '✓ This item now qualifies for Buy now — refresh the page to use it'
        : 'Add ' + formatMoney(remaining) + ' more to unlock Buy It Now';
    } else {
      message.textContent = unlocked
        ? '✓ Minimum order reached — you’re ready to check out'
        : 'Add ' + formatMoney(remaining) + ' more to unlock checkout';
    }
  }

  // The cart page/drawer Checkout button uses a real HTML `disabled`
  // attribute - browsers make that bulletproof against clicks, taps, and
  // keyboard activation, so it's safe to toggle live from JS. Same for its
  // cart-mode progress bar: purely informational, no security role.
  function applyCartState(totalCents) {
    cartTotalCents = totalCents;
    var unlocked = totalCents >= MIN_CENTS;

    document.querySelectorAll('[data-checkout-gate]').forEach(function (el) {
      if (unlocked) {
        el.removeAttribute('disabled');
        el.setAttribute('aria-disabled', 'false');
      } else {
        el.setAttribute('disabled', 'disabled');
        el.setAttribute('aria-disabled', 'true');
      }
    });

    document
      .querySelectorAll('[data-order-minimum-progress]:not([data-mode="product"])')
      .forEach(function (progress) {
        updateProgressElement(progress, totalCents, false);
      });

    document.querySelectorAll('[data-order-minimum-progress][data-mode="product"]').forEach(function (progress) {
      refreshProductProgress(progress);
    });
  }

  // Buy It Now / dynamic checkout buttons are rendered by Shopify's own
  // script, which forces itself clickable regardless of surrounding CSS -
  // a client-side "locked" overlay on top of a real button does not
  // reliably block it. So unlike the cart checkout button above, this gate
  // is decided once, server-side, in Liquid: the real button is only ever
  // rendered into the page when the order minimum is already met at that
  // moment (see buy-buttons.liquid). This progress bar is informational
  // only from here on - it can tell the customer they now qualify, but
  // can't make a real Buy It Now button appear without a page reload.
  function quantityForScope(scope) {
    var input = document.getElementById('Quantity-' + scope.dataset.sectionId);
    var value = input ? parseInt(input.value, 10) : 1;
    return isNaN(value) || value < 1 ? 1 : value;
  }

  function refreshProductProgress(progress) {
    var scope = progress.closest('[data-section-id]');
    var quantity = scope ? quantityForScope(scope) : 1;
    var unitPrice = parseInt(progress.dataset.unitPrice, 10) || 0;
    var currentCents = Math.max(unitPrice * quantity, cartTotalCents);
    updateProgressElement(progress, currentCents, true);
  }

  // Deliberately not calling refreshProductProgress() for every product-mode
  // progress bar on load: Liquid already rendered the correct message AND
  // the correct button together, from the same cart/price data, on this
  // exact page load - there is nothing to fix yet. Calling it here was the
  // bug: it unconditionally overwrote that correct message with the
  // JS "refresh the page to use it" wording, even on a page that had just
  // been loaded and needed no refreshing at all. From here on, JS only
  // needs to react to things that change the picture *after* load -
  // a quantity edit or a cart update - which is exactly what the listeners
  // below do.

  ['input', 'change'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        if (!event.target.matches || !event.target.matches('.quantity__input')) return;
        var scope = event.target.closest('[data-section-id]');
        if (!scope) return;
        scope.querySelectorAll('[data-order-minimum-progress][data-mode="product"]').forEach(refreshProductProgress);
      },
      true
    );
  });

  // Block the disabled checkout link/button from navigating even if CSS is
  // slow to apply or the user fires a synthetic click.
  document.addEventListener(
    'click',
    function (event) {
      var el = event.target.closest('[data-checkout-gate][aria-disabled="true"]');
      if (el) event.preventDefault();
    },
    true
  );

  // "Buy it now" when this product alone is below the minimum but the cart
  // already qualifies: add this product to the real cart, then send the
  // customer to the real cart's checkout - never a standalone single-item
  // checkout, so whatever gets purchased is genuinely above the minimum.
  function showBuyNowError(button, message) {
    var form = button.closest('product-form');
    var wrapper = form && form.querySelector('.product-form__error-message-wrapper');
    var text = form && form.querySelector('.product-form__error-message');
    if (wrapper && text) {
      text.textContent = message;
      wrapper.removeAttribute('hidden');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-buy-now-via-cart]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var quantityInput = document.getElementById(button.dataset.quantityInputId);
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    var originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    // Re-render the cart drawer from the add response, then press the
    // drawer's own Checkout button. That button is the checkout entry point
    // Razorpay Magic Checkout hooks into (its "cart selector"), so Buy now
    // opens Magic Checkout when it's enabled and falls back to Shopify's
    // checkout otherwise - always for the whole, above-minimum cart.
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionIds =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map(function (section) {
            return section.id;
          })
        : [];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: button.dataset.variantId,
        quantity: quantity,
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(Promise.reject.bind(Promise));
        return response.json();
      })
      .then(function (response) {
        if (!cartDrawer || !response.sections) {
          window.location.href = '/checkout';
          return;
        }
        cartDrawer.renderContents(response);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'buy-now-via-cart', cartData: response });
        }
        setTimeout(function () {
          var checkout = document.getElementById('CartDrawer-Checkout');
          if (checkout && !checkout.disabled) {
            checkout.click();
          } else {
            window.location.href = '/checkout';
          }
        }, 50);
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = originalLabel;
        showBuyNowError(button, (error && error.description) || 'Could not add this to your cart. Please try again.');
      });
  });

  // Initial cart-wide state comes from Liquid on first paint; keep it live
  // from here on.
  // Different publishers of cartUpdate hand back different payload shapes -
  // e.g. product-form.js's add-to-cart response has no total_price at all -
  // so always re-fetch the authoritative cart instead of trusting the event.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      return fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          applyCartState(cart.total_price);
        })
        .catch(function () {});
    });
  }
})();
